module.exports = __webpack_public_path__ + "static/media/calendar.76db51be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/calendar.svg
// module id = 693
// module chunks = 0